/* eslint-disable no-console */
import { httpModule } from '@shared/http';

import { Person } from '@/assets/entities';

export type Propietor = {
    id: number;
    cuit: string;
    managementFee: number;
    entranceDate?: string;
    terminationDate?: string;
    terminationReason?: string;
    notes: string;
    person: Person;
    organization?: number;
    hasAssociatedContract?: boolean;
};

export type PropietorFilters = {
    firstname: string;
    lastname: string;
    dni: number;
    email: string;
    phone: string;
    minProperties: string;
    maxProperties: string;
}

export async function fetchPropietors(
    page?: number,
    limit?: number,
    search?: string,
    firstname?: string,
    lastname?: string,
    email?: string,
    document?: number,
    phone?: string,
    minProperties?: number,
    maxProperties?: number
) {
    try {
        return await httpModule.get('/propietors', {
            params: {
                page,
                limit,
                search,
                firstname,
                lastname,
                email,
                document,
                phone,
                minProperties,
                maxProperties
            }
        });
    } catch (ex) {
        console.warn('Error fetching propietors');
        console.log(ex.response);
    }
}

export async function postPropietor(propietor: object) {
    try {
        return await httpModule.post('/propietors', propietor);
    } catch (ex) {
        console.warn('Error posting the propietor');
        console.log(ex.response);
    }
}

export async function patchPropietor(propietor: object) {
    try {
        return await httpModule.patch('/propietors', propietor);
    } catch (ex) {
        console.warn('Error patching the propietor');
        console.log(ex.response);
    }
}

export async function getPropietorByID(id: number) {
    try {
        return await httpModule.get(`/propietors/${id}`);
    } catch (ex) {
        console.warn('Error getting a propietor');
        console.log(ex.response);
    }
}

export async function deletePropietor(id: number) {
    try {
        return await httpModule.delete(`/propietors/${id}`);
    } catch (ex) {
        console.warn('Error deleting a propietor');
        console.log(ex.response);
    }
}

